export enum EPlanModule {
  SITE = 'site',
  POINT = 'point',
}
